'use client';

import { ALGOLIA_CONFIG, cn } from '@/app/lib';
import { Icon, Typography } from '@workspace/ui/common';

export type SearchAllFilterOption = 'all' | 'document' | 'product' | 'article';

interface FilterConfig {
  key: SearchAllFilterOption;
  label: string;
  icon: string;
  refinementValues: string;
}

interface SearchFilterRadioProps {
  title?: string;
  activeFilter?: SearchAllFilterOption;
  onChange?: (filter: SearchAllFilterOption) => void;
  className?: string;
}

export const SEARCH_ALL_FILTER_CONFIGS: FilterConfig[] = [
  {
    key: 'all',
    label: 'All',
    icon: 'Search',
    refinementValues: ALGOLIA_CONFIG.LIST_INSTANT_SEARCH_INDEX.SearchAll,
  },
  {
    key: 'document',
    label: 'Document',
    icon: 'FileBend',
    refinementValues: ALGOLIA_CONFIG.LIST_INSTANT_SEARCH_INDEX.Documents,
  },
  {
    key: 'product',
    label: 'Product',
    icon: 'LayoutThird',
    refinementValues: ALGOLIA_CONFIG.LIST_INSTANT_SEARCH_INDEX.SearchAllProducts,
  },
  {
    key: 'article',
    label: 'Case Study & Blogs',
    icon: 'EditList',
    refinementValues: ALGOLIA_CONFIG.LIST_INSTANT_SEARCH_INDEX.Articles,
  },
];

export function SearchFilterRadio({
  title = 'Filter',
  activeFilter = 'all',
  className = '',
  onChange,
}: SearchFilterRadioProps) {
  return (
    <div className={`space-y-xs md:space-y-md ${className}`}>
      <Typography as="p" variant="h6" className="text-base font-openSans">
        {title}
      </Typography>
      <div className="flex md:flex-col flex-wrap md:flex-nowrap gap-xs md:gap-sm md:items-start">
        {SEARCH_ALL_FILTER_CONFIGS.map((config) => (
          <button
            key={config.key}
            type="button"
            className={cn(
              'text-base font-semibold font-sora px-md py-xs rounded-full border border-secondary-200 cursor-pointer flex items-center text-start gap-xs hover:text-primary hover:border-primary',
              'md:rounded md:px-0 md:py-0 md:w-full md:border-transparent md:hover:underline md:hover:border-transparent',
              activeFilter === config.key ? 'text-primary border-primary md:underline ' : 'text-secondary-400',
            )}
            onClick={() => onChange?.(config.key)}
            aria-pressed={activeFilter === config.key}
          >
            <Icon name={config.icon as any} size={20} className="hidden md:block" />
            {config.label}
          </button>
        ))}
      </div>
    </div>
  );
}
